import PropTypes from 'prop-types';

export default function OutlineLock(props) {
    const { color = 'currentColor', size = 20, strokeWidth = 1.5, ...rest } = props;

    return (
        <svg viewBox="0 0 20 20" fill="none" width={size} height={size} {...rest}>
            <path
                d="M16.333 9.167H4.667c-.92 0-1.667.746-1.667 1.666v5.834c0 .92.746 1.666 1.667 1.666h11.666c.92 0 1.667-.746 1.667-1.666v-5.834c0-.92-.746-1.666-1.667-1.666ZM6.333 9.167V5.833a4.167 4.167 0 1 1 8.334 0v3.334"
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={strokeWidth}
            />
        </svg>
    );
}

OutlineLock.propTypes = {
    color: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    strokeWidth: PropTypes.number,
};
